import axios from "axios";
import * as apiConstants from "../constants/api-constants";
import { CRITICAL_ERRORS } from "../constants/errorConstants";

/**
 * Event emitter for handling API errors globally
 */
class ErrorEventEmitter extends EventTarget {
  /**
   * Emits an error event to show global error modal
   * @param {string} errorCode - Error code from CRITICAL_ERRORS
   * @param {string} customMessage - Custom error message (fallback)
   */
  emitError(errorCode, customMessage) {
    const message =
      CRITICAL_ERRORS[errorCode] ||
      customMessage ||
      'Ha ocurrido un error inesperado'
    this.dispatchEvent(
      new CustomEvent('apiError', {
        detail: { message },
      })
    )
  }
}

export const errorEmitter = new ErrorEventEmitter()

export const axiosInstance = axios.create();

//Get ip Address
const holderVariables = {}

async function getIp() {
  if (holderVariables.ip) {
    return holderVariables.ip
  }
  if (sessionStorage.getItem("ipAddress")) {
    holderVariables.ip = sessionStorage.getItem("ipAddress")
    return holderVariables.ip
  }
  holderVariables.ip = new Promise((resolve) => {
    axios
      .get(apiConstants.GET_IP_ADDRESS, { timeout: 5000 })
      .then(response => {
        sessionStorage.setItem("ipAddress", response.data.ip)
        resolve(response.data.ip)
      })
      .catch(() => {
        resolve('127.0.0.1')
      })
  })
  return holderVariables.ip
}

axiosInstance.interceptors.request.use(async (config) => {
  const tokenResponse = sessionStorage.getItem("ipAddress") ? sessionStorage.getItem("ipAddress") : await getIp();
  config.headers['Ip-Address'] = tokenResponse;
  return config;
}, (error) => {
  return Promise.reject(error);
});

axiosInstance.interceptors.response.use(
  response => {
    if (response.data?.errorCode && CRITICAL_ERRORS[response.data.errorCode]) {
      errorEmitter.emitError(response.data.errorCode);
      return Promise.reject(new Error(CRITICAL_ERRORS[response.data.errorCode]));
    }
    return response;
  },
  error => {
    return Promise.reject(error);
  }
);
